import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../types.tsx';
import type { Response } from './types.tsx';

const getIsSampleProject = async (projectKey: string): Promise<boolean> => {
	try {
		const response: Response = await performGetRequest(
			`/rest/api/3/project/${projectKey}/properties/isDemo`,
		);
		return response.value;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		return false;
	}
};

export const fetchIsSampleProject =
	(projectKey: string): Action<State> =>
	async ({ getState, setState }) => {
		const currentState = getState();

		if (projectKey in currentState) {
			return;
		}

		const isSampleProject = await getIsSampleProject(projectKey);

		setState({
			[projectKey]: isSampleProject,
		});
	};
